import { Checkbox } from '@insurancemenu/imenu-components-lib';
import { Carrier, CartItem } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import ProductLineTitle from 'components/common/general/ProductLineTitle';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { useRootStore } from 'store/rootStore';
import BookmarkedPlanCard from '../BookmarkedPlanCard';
import { createStyles } from './styles';

export interface BookmarkedSectionProps {
  carrier: Carrier;
  cartItemsByPLine: CartItem[];
  productLineId: ProductLineId;
}

const BookmarkedSection = observer(
  ({ carrier, cartItemsByPLine, productLineId }: BookmarkedSectionProps): JSX.Element => {
    const {
      contactMeModalStore: { isProductLineSelected, onSelectedProductLineChange },
    } = useRootStore();

    const isPLineChecked = isProductLineSelected(productLineId);

    const onChange = (): void => {
      onSelectedProductLineChange(productLineId);
    };

    const classes = createStyles(cartItemsByPLine.length > 0);
    return (
      <div>
        {cartItemsByPLine.length === 0 ? (
          <div className={classes.productLineCheckbox}>
            <Checkbox
              label={<ProductLineTitle productLineId={productLineId} styles={classes.productLineTitle} />}
              checked={isPLineChecked}
              onChange={onChange}
            />
          </div>
        ) : (
          <div className={classes.plansWrapper}>
            <Checkbox
              label={<ProductLineTitle productLineId={productLineId} styles={classes.productLineTitle} />}
              checked
              disabled
            />
            {cartItemsByPLine.map(({ portfolioName, portfolioId }) => {
              return <BookmarkedPlanCard portfolioName={portfolioName} key={portfolioId} carrier={carrier} />;
            })}
          </div>
        )}
      </div>
    );
  },
);

export default BookmarkedSection;
